<div class="flex flex-col h-full">

  <div class="min-h-80 max-h-[600px] flex-1 overflow-y-auto px-2">

    @if (isLoading()) {
      <elcia-loader/>
    } @else if (timesheets().length === 0) {
      <div class="flex flex-col items-center justify-center h-full text-center select-none text-[var(--p-surface-400)]">
        <i class="pi pi-clock text-4xl mb-3 opacity-40"></i>
        <p class="text-sm font-medium">{{ 'app.no-timesheet' | translate }}</p>
      </div>
    } @else {
      <div class="flex flex-col gap-2">
        @for (timesheet of timesheets(); track timesheet.id) {
          <div (click)="openTimesheet(timesheet)"
               class="flex flex-col gap-1 p-3 rounded-xl border border-primary-50 bg-[var(--p-surface-50)] cursor-pointer hover:bg-primary-50 transition-colors">

            <div class="flex items-center justify-between gap-2">
              <span class="text-sm font-medium truncate">{{ timesheet.subject }}</span>
              <span class="text-sm font-semibold shrink-0">{{ timesheet.durationInSeconds | duration }}</span>
            </div>

            <div class="flex items-center justify-between gap-2 text-xs text-[var(--p-surface-500)]">
              <span class="truncate">
                {{ timesheet.date | date: 'dd/MM/yyyy' }}
                · {{ timesheet.startTime | date: 'HH:mm' }}-{{ timesheet.endTime | date: 'HH:mm' }}
                · {{ timesheet.timesheetType.name }}
              </span>
              <div class="flex items-center gap-1 shrink-0">
                @if (timesheet.isBillable) {
                  <elcia-icon iconSize="sm" iconType="finances"/>
                }
                <elcia-avatar [avatars]="timesheet.createdBy ? [timesheet.createdBy] : []" [maxItem]="1"/>
              </div>
            </div>

          </div>
        }
      </div>
    }

  </div>

  @if (timesheets().length > 0) {
    <div class="px-2">
      <p-divider/>
      <div class="flex items-center justify-between text-sm font-semibold">
        <span>{{ 'timesheet.total' | translate }}</span>
        <span>{{ totalDurationInSeconds() | duration }}</span>
      </div>
    </div>
  }

</div>

@if (isFormDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogSave()"
    (onClose)="closeForm()"
    (onDelete)="deleteTimesheet()"
    [isActionLoading]="isFormSaving()"
    [mustDisplayDeleteButton]="true"
    [size]="'medium'"
    [title]="'entity.timesheet' | translate">

    @if (isLoadingSelectedTimesheet()) {
      <elcia-loader/>
    } @else {
      <elcia-timesheet-form
        (onSubmit)="submit($event)"
        [documents]="selectedTimesheetDocuments()"
        [initialValue]="selectedTimesheet()"/>
    }
  </elcia-dialog>
}
